const normalizeSlug = (value) => String(value || '').trim().toLowerCase();

const toOptions = (languages = []) => (
    languages
        .filter(Boolean)
        .map((language) => ({
            id: language.id,
            label: language.label || language.slug,
            slug: normalizeSlug(language.slug),
            status: language.status,
        }))
        .filter((language) => language.slug)
);

const toMap = (languages = []) => (
    toOptions(languages).reduce((result, language) => ({
        ...result,
        [ language.slug ]: language,
    }), {})
);

const getLanguage = (value, languageMap = {}) => {
    const slug = normalizeSlug(value);

    return languageMap[ slug ];
};

const getLanguageLabel = (value, languageMap = {}) => {
    const language = getLanguage(value, languageMap);

    return language?.label || value || null;
};

const LanguageOptionsHelper = {
    normalizeSlug,
    toOptions,
    toMap,
    getLanguage,
    getLanguageLabel,
};

export default LanguageOptionsHelper;
